import React from "react";
import firebase from "firebase/compat";

interface AuthContextInterface {
    user: firebase.User | null;
    initialized: boolean;
}

export const AuthContext = React.createContext<AuthContextInterface>({user: null, initialized: false});